import { inject, Injectable } from '@angular/core';
import { SUPPORT_EMAIL_ADDRESS } from '@reconcept-platform/env';
import {
  type SendMailMutationMutation,
  type SendMailMutationMutationVariables,
} from '@reconcept-platform/shared/types';
import { SharedGraphQlService } from '../../services/shared-graphql.service';
import { SendMailMutation } from './send-mail.mutation';

@Injectable({
  providedIn: 'root',
})
export class SendMailApi {
  private graphQl = inject(SharedGraphQlService);
  private supportEmailAddress = inject(SUPPORT_EMAIL_ADDRESS);

  sendMailToSupport(subject: string, body: string, emailAddress = this.supportEmailAddress) {
    return this.sendMail(subject, body, [emailAddress]);
  }

  private sendMail(subject: string, body: string, emailAddresses: string[]) {
    return this.graphQl.mutateV2<SendMailMutationMutation, SendMailMutationMutationVariables>({
      mutation: SendMailMutation,
      variables: {
        input: {
          body,
          emailAddresses,
          subject,
        },
      },
    });
  }
}
